'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.anchorScroll = twentyninetimes.anchorScroll || function () {

	function init() {
		anchor_scroll();
	}

	function anchor_scroll() {
	    var anchor_link 	= document.querySelectorAll('a[href^="#"]');

	    for (var i = 0; i < anchor_link.length; i++) { 
	    	anchor_link[i].addEventListener('click', function(e) {
	    		e.preventDefault();

	    		var anchor_attr = this.getAttribute('href').replace('#', ''),
	    			elmnt_scroll_to = document.getElementById(anchor_attr),
	                scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop),
	                header_height = window.innerWidth > 991 ? 130 : 120,
	                elmnt_scrollTop = scrollTop + elmnt_scroll_to.getBoundingClientRect().top - header_height;
	            
	    		scrollTo(elmnt_scrollTop, 500);

	    		//window.history.replaceState(null, null, '#'+anchor_attr);
	    	});
	    }
	}

	function setUrlParams(value) {
	  // Construct URLSearchParams object instance from current URL querystring.
	  var queryParams = new URLSearchParams(window.location.search);
	   
	  // Set new or modify existing parameter value. 
	  queryParams.set(value);
	   
	  // Replace current querystring with the new one.
	  history.replaceState(null, null, "#"+queryParams.toString());
	}

	return {
		init : init
	};

}();

var scrollTo = function(to, duration) {
    var	element = document.scrollingElement || document.documentElement,
        start = element.scrollTop,
        change = to - start,
        startDate = +new Date(),
        // t = current time
        // b = start value
        // c = change in value
        // d = duration
        easeInOutQuad = function(t, b, c, d) {
            t /= d/2;
            if (t < 1) return c/2*t*t + b;
            t--;
            return -c/2 * (t*(t-2) - 1) + b;
        },
        animateScroll = function() {
            var currentDate = +new Date();
            var currentTime = currentDate - startDate;
            element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
            if(currentTime < duration) {
                requestAnimationFrame(animateScroll);
            }
            else {
                element.scrollTop = to;
            }
        };
        
    animateScroll();
};